<div class="body-2" [ngStyle]="asignaEstiloBody()">
    <div class="sign-up-wrap smallw">
        <img [src]="srcLogo" alt="" class="logoIngreso" [ngStyle]="asignaEstiloLogo()">
        <h4 class="colortituloingreso">Ingresar a {{sitio}}</h4>
        <p class="ocultarsmallw"><br></p>
        <div class="w-form">
            <form [formGroup]="formIngreso" (ngSubmit)="loginSubmit($event.submitter.id)" #loginForm="ngForm"
                id="ingreso-form" name="ingreso-form" data-name="Formulario de Ingreso">

                <small class="form-text text-muted">
                    <a class="colortextoingreso">Ingrese su e-mail</a>
                </small>
                <div class="lineadetusrped">
                    <div class="w-col w-col-12">
                        <input type="email" formControlName="fTxtMail" [ngStyle]="asignaEstilo(formIngreso, 'fTxtMail')"
                            name="fTxtMail" data-name="fTxtMail" id="fTxtMail" required="" placeholder="e-mail"
                            class="text_field w-input" minlength="5" maxlength="256" #spy>
                        <!-- <br>spy es un truco para ver datos de un elemento, como: {{spy.className}} -->
                    </div>
                </div>

                <small class="form-text text-muted">
                    <a class="colortextoingreso">Password: long >=8, minúsculas, mayúsculas, números y signos</a>
                </small>
                <div class="linealogin">
                    <div class="w-col w-col-8">
                        <input type="password" formControlName="fTxtPwd"
                            [ngStyle]="asignaEstilo(formIngreso, 'fTxtPwd')" name="fTxtPwd" data-name="fTxtPwd"
                            id="fTxtPwd" required="" placeholder="Password" class="text_field w-input" minlength="8"
                            maxlength="256">
                    </div>
                    <div class="w-col w-col-4">
                        <button type="button" class="boton_accion" id="btnTogglePwd" (click)="togglePwd()">
                            Ver
                        </button>
                    </div>
                </div>
                <div class="lineadetusrped">
                    <div class="w-col w-col-4">
                        <input type="submit" [disabled]="!formIngreso.valid"
                            [ngStyle]="asignaEstiloSubmitDisabled(formIngreso)" value="Entrar"
                            data-wait="Un momento, por favor..." id="fBtnIngresar" class="button w-button font16 smallw">
                    </div>
                    <div class="w-col w-col-4">
                        <input type="submit" [disabled]="!formIngreso.valid"
                            [ngStyle]="asignaEstiloSubmitDisabled(formIngreso)" value="Solicitar"
                            data-wait="Un momento, por favor..." id="fBtnSolicitar" class="button w-button font16 smallw">
                    </div>
                    <div class="w-col w-col-4">
                        <input type="submit" routerLink="/sitio-publico/inicio" value="Salir"
                            data-wait="Un momento, por favor..." id="fBtnSalir" class="button w-button font16 smallw">
                    </div>
                </div>
                <!--
                    <h4 *ngIf="mensajeLogin!==''">{{mensajeLogin}}</h4>
                    <h4 *ngIf="mensajeLogin2!==''">{{mensajeLogin2}}</h4>
                -->
            </form>
            <!--
            <div class="w-form-done">
                <div>Datos enviados</div>
            </div>
            <div class="w-form-fail">
                <div>Oops! Algo falló en el envío.</div>
            </div>
            -->
            <p class="paragraph-12">Al ingresar a {{sitio}}, Usted acepta los <a routerLink="/sitio-publico/terminos"
                    class="link">Términos de Uso y Política de Privacidad</a>.<br></p>
        </div>
        <div class="sign-up smallw">
            <p class="paragraph-12">No tiene un usuario? <a routerLink="/sitio-publico/nuevoUsr" class="link">Cree una
                    cuenta</a><br></p>
            <p class="paragraph-12">No recuerda su password? <a routerLink="/sitio-publico/cambioPwd"
                    class="link">Presione aquí</a><br></p>
        </div>
    </div>
</div>